import { MODAL_DEFAULT_SCREEN } from '@/config';
import { TScreens } from '@/containers/Modal';

import { TVoucherList } from '@/context/PurchaseProvider';
import { TParsedContentResult } from '@/services/requests/Liferay/types';
import { clearHtmlTags } from '../HtmlHelper/clearHtmlTags';

export const getInitialScreenHelper = (
  voucherList: TVoucherList,
  voucherNumber?: string,
  isModal?: string,
  contentData?: TParsedContentResult
): {
  screen: TScreens;
  voucherNumber: string;
} => {
  if (voucherNumber) {
    const voucher =
      voucherList.all.find(v => voucherNumber === v.voucherNumber) ||
      voucherList.all[0];

    let newScreen = 'dashboard' as TScreens;

    if (voucher.type === 'AIRLINE') {
      newScreen = 'airlineVoucherRules';
    }
    if (isModal) {
      newScreen = 'rules';
    }

    return {
      screen: newScreen,
      voucherNumber: voucher.voucherNumber,
    };
  }

  if (voucherList.milesPurchase.length > 0 && voucherList.airline.length > 0) {
    return {
      screen: 'dashboardVoucherAerea',
      voucherNumber: '',
    };
  }

  if (voucherList.milesPurchase.length > 0) {
    const milesPurchaseVoucherLink = contentData?.rcs_modal_select_voucher_type?.milesPurchaseVoucherLink?.text || '';
    window.location.href = clearHtmlTags(milesPurchaseVoucherLink);
  }
  if (voucherList.airline.length > 0) {
    const airlineVoucherLink = contentData?.rcs_modal_select_voucher_type?.airlineVoucherLink?.text || '';
    window.location.href = clearHtmlTags(airlineVoucherLink);
  }
  

  return {
    screen: MODAL_DEFAULT_SCREEN,
    voucherNumber: '',
  };
};
